import { Button, theme } from "antd";
import React, { useState, useRef, useEffect } from "react";
import {
    BoldOutlined,
    ItalicOutlined,
    UnderlineOutlined,
    UnorderedListOutlined,
    StrikethroughOutlined,
    OrderedListOutlined
} from '@ant-design/icons';

const TextEditor = ({name,onchangefunction,item,row,focusedField,inputRef}) => {
    const [htmlContent, setHtmlContent] = useState("");
    const [showTooltip, setShowTooltip] = useState(false);
    const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
    const textAreaRef = useRef(null);
    const [comHtmlContent, setcomHtmlContent] = useState("<div><u><b>This approach</b> <i>will give you</i></u> the basic functionality you're looking for without relying on external libraries.</div>")
    const {
        token: {
            colorBgContainer,
            borderRadiusLG,
            colorBorder,
        },
    } = theme.useToken();

    //const initialHtml = "<div><u><b>This approach</b> <i>will give you</i></u> the basic functionality you're looking for without relying on external libraries.</div>";

    // useEffect(()=>{
    //     let obj = {
    //         target:{
    //             value:comHtmlContent
    //         }
    //     }
    //    onchangefunction(obj,item.cellId,row);
    // },[])

    const formatText = (command) => {
        document.execCommand(command, false, null);
        updateHtmlContent();
        setShowTooltip(false);
    };

    const updateHtmlContent = () => {
        const currentHtml = textAreaRef.current.innerHTML;
        setHtmlContent(currentHtml);
        console.log(name,"text area name")
        console.log(textAreaRef.current.innerHTML,"textAreaRef.currentname")
        // inputRef.current[name]=textAreaRef.current.innerHTML;
        // setFocusedField(name)
        setcomHtmlContent(currentHtml);
        let obj = {
            target:{
                value:currentHtml
            }
        }
        onchangefunction(obj,item.cellId,row);

        console.log("Generated HTML:", currentHtml);
    };

    const handleTextSelection = (event) => {
        const selection = window.getSelection();
        if (selection && selection.toString().length > 0) {
            const range = selection.getRangeAt(0);
            const rect = range.getBoundingClientRect();
            const textAreaRect = textAreaRef.current.getBoundingClientRect();
            
            // Calculate tooltip position relative to the text area
            setTooltipPosition({ 
                top:  - 20, // Adjust to position tooltip above the selection
            });
            setShowTooltip(true);
        } else {
            setShowTooltip(false);
        }
    };

    useEffect(() => {
        // Only listen for mouseup events inside this text editor
        const handleMouseUp = (event) => {
            if (textAreaRef.current.contains(event.target)) {
                handleTextSelection(event);
            }
        };

        document.addEventListener("mouseup", handleMouseUp);
        return () => {
            document.removeEventListener("mouseup", handleMouseUp);
        };
    }, []);

    useEffect(() => {
        //console.log("teaxt area use effect");
        if(item.value !== "") {
            setcomHtmlContent(item.value); 
            textAreaRef.current.innerHTML = item.value;
        }else{
            textAreaRef.current.innerHTML = comHtmlContent;
        }
        
    }, []);

    return (
        <div style={{ flex: 1, padding: "10px", position: "relative", marginTop:16 }}>
            {showTooltip && (
                <div
                    style={{
                        position: "absolute",
                        top: `${tooltipPosition.top}px`,
                        left: `${tooltipPosition.left}px`,
                        backgroundColor: colorBgContainer,
                        padding: "5px",
                        borderRadius: borderRadiusLG,
                        display: "flex",
                        gap: "5px",
                        marginTop:"12px"
                    }}
                >
                    <Button onClick={() => formatText("bold")} icon={<BoldOutlined />} />
                    <Button onClick={() => formatText("italic")} icon={<ItalicOutlined />} />
                    <Button onClick={() => formatText("underline")} icon={<UnderlineOutlined />} />
                    <Button onClick={() => formatText("strikeThrough")} icon={<StrikethroughOutlined />} />
                    <Button onClick={() => formatText("insertUnorderedList")} icon={<UnorderedListOutlined />} />
                    <Button onClick={() => formatText("insertOrderedList")} icon={<OrderedListOutlined />} />
                </div>
            )}
            <div
                name={name}
                ref={textAreaRef}
                contentEditable
                suppressContentEditableWarning={true}
                style={{
                    border: `1px solid ${colorBorder}`,
                    borderRadius: borderRadiusLG,
                    minHeight: 100,
                    padding: 16,
                    overflowY: "auto",
                }}
                onInput={updateHtmlContent}
            ></div>
        </div>
    );
};

export default TextEditor;
